import React from 'react';

import ChannelSelectorChannel from '../ChannelSelectorChannel';
import ChannelSelectorNoChannel from '../ChannelSelectorNoChannel';
import Dropdown from 'react-bootstrap/Dropdown';

const ChannelSelectToggleButton = (props) => {
  const { selectedChannel, isOpen } = props;

  const caretIcon = isOpen ? 'far fa-angle-up' : 'far fa-angle-down';

  const buttonContents = selectedChannel ? (
    <ChannelSelectorChannel channel={selectedChannel} />
  ) : (
    <ChannelSelectorNoChannel />
  );

  return (
    <Dropdown.Toggle
      bsPrefix="selector-button"
      className="ChannelSelector__dropdownToggle selector-button gecko-btn"
      variant="naked"
      size="sm"
    >
      {buttonContents}
      <i className={caretIcon} />
    </Dropdown.Toggle>
  );
};

export default ChannelSelectToggleButton;
